/**
 * This symbol qualifies an action for the API Middleware.
 */
export const CALL_API = Symbol("Call API")
